import { render } from "./startimes.vue?vue&type=template&id=19fe10a2&scoped=true"
import script from "./startimes.vue?vue&type=script&lang=js"
export * from "./startimes.vue?vue&type=script&lang=js"

import "./startimes.vue?vue&type=style&index=0&id=19fe10a2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\admin-tapit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19fe10a2"]])

export default __exports__